<template>
  <div id="ExportDiscontinuousManage" class="well" style="padding: 0 1em">
    <b-button variant="success" v-on:click="dataMode = 1"
      >匯出未連續(在學生)</b-button
    >
    <b-button variant="success" v-on:click="dataMode = 2"
      >匯出全學期(在學生、休學生、退學生)</b-button
    >

    <div>目前共 {{ total }}筆</div>
    <b-tabs content-class="mt-3" justified>

      <b-tab :active="dataMode == 1" :disabled="dataMode != 1">
        <table cellpadding="0" cellspacing="0" class="ncut-table-search">
          <tbody>
            <thead class="ncut-thead-menu">
              <tr>
                <th style="min-width: 6em">申請上一個學年度(狀態:準備撥款)：</th>
                <th style="min-width: 2em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="3"
                    v-model="queryInfo.STime"
                    placeholder="如111"
                  />
                </th>

                <th style="min-width: 2em">上一個學期：</th>
                <th style="min-width: 2em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="1"
                    v-model="queryInfo.ETime"
                    placeholder="如1"
                  />
                </th>
                <th style="min-width: 6em">本學年度(狀態:全部)：</th>
                <th style="min-width: 2em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="3"
                    v-model="queryInfo.Text1"
                    placeholder="如111"
                  />
                </th>

                <th style="min-width: 2em">本學期：</th>
                <th style="min-width: 2em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="1"
                    v-model="queryInfo.Text2"
                    placeholder="如2"
                  />
                </th>

                <th style="min-width: 2em" >
                  <b-button variant="success"  @click="query1()"
                    ><b-icon icon="search" />&nbsp;{{
                      $t("message.Query_cmd")
                    }}</b-button
                  >&nbsp;

                  <a
                    style="margin: 0 0.5rem; text-decoration: none"
                    target="_blank"
                    tabindex="4"
                    class="ncut-excel-style"
                    :href="
                      './WebApi/EconomicDisadvantage/GetDiscontinuousListCSV/'
                        .concat(queryInfo.STime)
                        .concat(',')
                        .concat(queryInfo.ETime)
                        .concat(',')
                        .concat(queryInfo.Text1)
                        .concat(',')
                        .concat(queryInfo.Text2)
                    "
                    v-show="total > 0"
                  >
                    <img
                      src="@/assets/images/ods-file24.png"
                      style="height: 0.8rem"
                    />
                    {{ $t("message.CSV_txt") }}
                  </a>
                </th>
              </tr>
            </thead>
          </tbody>
        </table>

        <div
          class="dataTables_scrollBody"
          style="
            position: relative;
            overflow: auto;

            max-height: 400px;

            width: 100%;
            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "
        >
          <table
            class="ncut-table-menu-striped ncut-table-menu"
            bgcolor="#FFFFFF"
          >
            <thead class="ncut-thead-menu">
              <tr>
                <th style="min-width: 5em">流水號</th>
                <th style="min-width: 5em">學生身分證字號</th>

                <th style="min-width: 5em">學生姓名</th>

                <th style="min-width: 5em">學號</th>
                <th style="min-width: 5em">學制</th>
                <th style="min-width: 1em">部別</th>
                <th style="min-width: 2em">年級</th>
                <th style="min-width: 2em">電子郵件</th>
                <th style="min-width: 2em">手機號碼</th>
                <th style="min-width: 2em">專班編號</th>
                <th style="min-width: 2em">學生關係人1身分字號</th>
                <th style="min-width: 2em">學生關係人1身分別</th>
                <th style="min-width: 2em">學生關係人2身分字號</th>
                <th style="min-width: 2em">學生關係人2身分別</th>

                <th style="min-width: 2em">學生關係人3身分字號</th>
                <th style="min-width: 2em">學生關係人3身分別</th>
                <th style="min-width: 2em">關係人總數</th>
              </tr>
            </thead>
            <tbody class="ncut-tbody-menu">
              <tr
                v-for="(item, index) in docRecordList"
                :key="item.id"
                :index="item.id"
                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
                <td style="text-align: right">
                  {{ item.id }}
                </td>
                <td style="text-align: left">{{ item.idNo }}</td>
                <td style="text-align: left">{{ item.name }}</td>
                <td style="text-align: left">{{ item.sid }}</td>
                <td style="text-align: left">5</td>
                <td style="text-align: left">2</td>
                <td style="text-align: left">{{ item.gd }}</td>
                <td style="text-align: left">{{ item.eMail }}</td>
                <td style="text-align: left">{{ item.contactPhone }}</td>
                <td style="text-align: left">{{ item.specialClassNumber }}</td>
                <td style="text-align: left">{{ item.relatedId1 }}</td>
                <td style="text-align: left">{{ item.relatedStudent1 }}</td>
                <td style="text-align: left">{{ item.relatedId2 }}</td>
                <td style="text-align: left">{{ item.relatedStudent2 }}</td>
                <td style="text-align: left">{{ item.relatedId3 }}</td>
                <td style="text-align: left">{{ item.relatedStudent3 }}</td>
                <td style="text-align: left">{{ item.relatedTotal }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-tab>

      <b-tab :active="dataMode == 2" :disabled="dataMode != 2">
        <table cellpadding="0" cellspacing="0" class="ncut-table-search">
          <tbody>
            <thead class="ncut-thead-menu">
              <tr>
                <th style="min-width: 6em">申請學年度(全部狀態)：</th>
                <th style="min-width: 2em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="3"
                    v-model="queryInfo.STime"
                    placeholder="如111"
                  />
                </th>

                <th style="min-width: 2em">申請學期：</th>
                <th style="min-width: 2em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="1"
                    v-model="queryInfo.ETime"
                    placeholder="如1"
                  />
                </th>


                <th style="min-width: 2em" >
                  <b-button variant="success"  @click="query()"
                    ><b-icon icon="search" />&nbsp;{{
                      $t("message.Query_cmd")
                    }}</b-button
                  >&nbsp;

                  <a
                    style="margin: 0 0.5rem; text-decoration: none"
                    target="_blank"
                    tabindex="4"
                    class="ncut-excel-style"
                    :href="
                      './WebApi/EconomicDisadvantage/GetAllListCSV/'
                        .concat(queryInfo.STime)
                        .concat(',')
                        .concat(queryInfo.ETime)

                    "
                    v-show="total > 0"
                  >
                    <img
                      src="@/assets/images/ods-file24.png"
                      style="height: 0.8rem"
                    />
                    {{ $t("message.CSV_txt") }}
                  </a>
                </th>
              </tr>
            </thead>
          </tbody>
        </table>

        <div
          class="dataTables_scrollBody"
          style="
            position: relative;
            overflow: auto;

            max-height: 400px;

            width: 100%;
            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "
        >
          <table
            class="ncut-table-menu-striped ncut-table-menu"
            bgcolor="#FFFFFF"
          >
            <thead class="ncut-thead-menu">
              <tr>
                <th style="min-width: 2em">流水號</th>
                <th style="min-width: 5em">學生身分證字號</th>

                <th style="min-width: 5em">學生姓名</th>

                <th style="min-width: 5em">學號</th>
                <th style="min-width: 5em">班級名稱</th>
                <th style="min-width: 1em">學制</th>
                <th style="min-width: 1em">部別</th>
                <th style="min-width: 1em">年級</th>
                <th style="min-width: 2em">電子郵件</th>
                <th style="min-width: 2em">手機號碼</th>
                <th style="min-width: 2em">目前狀態</th>
                <th style="min-width: 2em">專班編號</th>
                <th style="min-width: 2em">專班名稱</th>
                <th style="min-width: 2em">學生關係人1身分字號</th>
                <th style="min-width: 2em">學生關係人1身分別</th>
                <th style="min-width: 2em">學生關係人2身分字號</th>
                <th style="min-width: 2em">學生關係人2身分別</th>

                <th style="min-width: 2em">學生關係人3身分字號</th>
                <th style="min-width: 2em">學生關係人3身分別</th>
                <th style="min-width: 2em">關係人總數</th>
                <th style="min-width: 5em">銀行名稱</th>
                <th style="min-width: 5em">分行名稱</th>
                <th style="min-width: 5em">分行代碼</th>
                <th style="min-width: 5em">銀行帳號</th>
              </tr>
            </thead>
            <tbody class="ncut-tbody-menu">
              <tr
                v-for="(item, index) in docRecordList"
                :key="item.id"
                :index="item.id"
                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
                <td style="text-align: right">
                  {{ item.id }}
                </td>
                <td style="text-align: left">{{ item.idNo }}</td>
                <td style="text-align: left">{{ item.name }}</td>
                <td style="text-align: left">{{ item.sid }}</td>
                <td style="text-align: left">{{ item.clsnm }}</td>
                <td style="text-align: left">5</td>
                <td style="text-align: left">2</td>
                <td style="text-align: left">{{ item.gd }}</td>
                <td style="text-align: left">{{ item.eMail }}</td>
                <td style="text-align: left">{{ item.contactPhone }}</td>
                <td style="text-align: left">{{ getIsComplete(item.isComplete, item.reason) }}</td>
                <td style="text-align: left">{{ item.specialClassNumber }}</td>
                <td style="text-align: left">{{ item.specialClassName }}</td>
                <td style="text-align: left">{{ item.relatedId1 }}</td>
                <td style="text-align: left">{{ item.relatedStudent1 }}</td>
                <td style="text-align: left">{{ item.relatedId2 }}</td>
                <td style="text-align: left">{{ item.relatedStudent2 }}</td>
                <td style="text-align: left">{{ item.relatedId3 }}</td>
                <td style="text-align: left">{{ item.relatedStudent3 }}</td>
                <td style="text-align: left">{{ item.relatedTotal }}</td>
                <td style="text-align: left">{{ item.postname  }}</td>
                <td style="text-align: left">{{ item.postsubName }}</td>
                <td style="text-align: left">{{ item.postsubID }}</td>
                <td style="text-align: left">{{ item.postno }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-tab>


    </b-tabs>
  </div>
</template>

<script  id="modal-template">
import * as tools from "../tool";
export default {
  name: "ExportDiscontinuousManage",
  data() {
    return {
      total: 0,
      dataMode: 1,
      currentPage: 1,
      selectedRowIndex: 0,
      editId: 0,
      pageSize: 10,
      queryInfo: {
        STime: null,
        ETime: null,
        Text1: null,
        Text2:null,
      },
      docRecordList: null,
    };
  },

  computed: {
    sysId() {
      return this.$store.getters.getSysId;
    },
    setting() {
      return this.$store.getters.getSetting;
    },

    filteredDocs: function () {
      let data = [];
      if (this.docRecordList != null) {
        data = this.docRecordList.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
      }
      return data;
    },
    headerColor() {
      return "#f7e8aa";
    },
  },
  filters: {},
  methods: {
    getIsComplete(id, reason) {
      var ret;
      if (id == 0) ret = "待審核";
      else if (id == 1) ret = "已核准";
      else if (id == 2) {
        ret = "通過財政調查";
      } else if (id == 3) {
        ret = "退回(" + reason + ")";
      } else if (id == 4) {
        ret = "退學";
      } else if (id == 5) {
        ret = "準備撥款";
      }
      else ret = "未知狀態";

      return ret;
    },
    checkSaveData1() {
      let msg = "";
      if (this.isEmpty(this.queryInfo.STime)) msg = "請輸入申請上一個學年度";
      else if (this.isEmpty(this.queryInfo.ETime)) msg = "請輸入上一個學期";
      else if (this.isEmpty(this.queryInfo.Text1) ) msg = "請輸入本學年度";
      else if (this.isEmpty(this.queryInfo.Text2) ) msg = "請輸入本學期";

      return msg;
    },
    checkSaveData() {
      let msg = "";
      if (this.isEmpty(this.queryInfo.STime)) msg = "請輸入申請學年度";
      else if (this.isEmpty(this.queryInfo.ETime)) msg = "請輸入申請學期";


      return msg;
    },
    query() {//匯出全學期
      var msg = this.checkSaveData();
      if (0 == msg.length) {
        let vm = this;
        vm.docRecordList = null;
        vm.total = 0;


        this.$http
          .put("./WebApi/EconomicDisadvantage/GetAllList", vm.queryInfo)
          .then((response) => {
            if (response.data != null) {
              vm.docRecordList = response.data;
              vm.total = vm.docRecordList.length;
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      } else {
        tools.showAlert(this, "danger", "對不起,請輸入" + msg);
      }
    },
    isEmpty(data) {
      return data != "" && data != null && data != undefined && data.length > 0
        ? false
        : true;
    },
    query1() {
      var msg = this.checkSaveData1();
      if (0 == msg.length) {
        let vm = this;
        vm.docRecordList = null;
        vm.total = 0;


        this.$http
          .put("./WebApi/EconomicDisadvantage/GetDiscontinuousList", vm.queryInfo)
          .then((response) => {
            if (response.data != null) {
              vm.docRecordList = response.data;
              vm.total = vm.docRecordList.length;
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      } else {
        tools.showAlert(this, "danger", "對不起,請輸入" + msg);
      }
    },
  },
  created() {
    console.log("======created ReportManageView =====");
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn1 {
  color: #e2e1e4;
  background-color: #c1651a;
  border-color: #a7a8bd;
}
.btn2 {
  color: #e2e1e4;
  background-color: #1a3b32;
  border-color: #a7a8bd;
}
.span_text {
  display: block;
  width: 20rem;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
</style>
